export default "__VITE_ASSET__ByE$Vam1__"